
const store = {
    subscribers:{},
    station: undefined,
    measurements: [],
    period: 24,//horas
    getPeriod(){
        return this.period
    },
    getStation(){
        return this.station
    },
    setStation(station){
        this.station = station
        this.publish('SET_STATION', station)
    },
    setMeasurements(measurements){
        this.measurements = measurements
        this.publish('SET_MEASUREMENTS', measurements)
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default store